import React, { FC } from 'react';
import { useVideoController } from '../../controller/video/VideoControlContext';
import { useAppState } from '../../state/AppState';
import UserAvatar from '../common/UserAvatar';
import { SELF_VIDEO_SIZE_PX } from '../party/AppConstants';
import { UnspotlightButton } from '../party/ParticipantBubble';

interface Props {
  style: React.CSSProperties;
}

const SelfVideoBubble: FC<Props> = ({ style }) => {
  const { selfVideoStream, setSelfVideo, avPermission, needsAVForArea } = useVideoController();
  const { party, user, enableAV } = useAppState();

  if (!user) {
    return <div />;
  }

  const participant = party?.stage.participants[user.uid];

  if (!participant) {
    return <div />;
  }

  return (
    <div className='self-video-container' style={style}>
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}>
        {avPermission === 'denied' && needsAVForArea && enableAV && (
          <div className='user-media-error'>ERROR</div>
        )}
        <UserAvatar
          size={SELF_VIDEO_SIZE_PX}
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
          }}
        />
        <div
          id='self-video'
          ref={setSelfVideo}
          style={{
            width: style.width,
            height: style.height,
            borderRadius: style.borderRadius,
            transform: 'scaleX(-1)',
            overflow: 'hidden',
            opacity: selfVideoStream?.hasVideo ? 1 : 0,
          }}></div>
        <UnspotlightButton participant={participant} />
      </div>
    </div>
  );
};

export default SelfVideoBubble;
